import { Color, DataTexture, FrontSide, RGBAFormat, ShaderMaterial, UniformsLib, UniformsUtils, Vector3 } from "three"
import handdrawnFragmentShader from '../shaders/handdrawn_2/fragment.glsl'
import handdrawnVertexShader from '../shaders/handdrawn_2/vertex.glsl'

class HanddrawnMaterial extends ShaderMaterial
{
    constructor(_options)
    {
        super()
        this.type = "HanddrawnMaterial"
        this.lights = true
        this.flatShading = false
        this.clipping = true
        this.transparent = true
        this.extensions.derivatives = true

        // Utils
        this.resources = _options.resources

        this.side = _options.side === undefined ? FrontSide : _options.side

        // Maps and colors
        this.baseColor = _options.baseColor || 0xffffff
        this.colorMap = _options.colorMap || this.resources.items.whiteTexture
        this.colorMapOverlay = _options.colorMapOverlay || 0xffffff
        this.roughnessMap = _options.roughnessMap || this.resources.items.whiteTexture
        this.opacityMap = _options.opacityMap || this.resources.items.whiteTexture

        this.colorMapOpacity = _options.colorMapOpacity === undefined ? 1 : _options.colorMapOpacity

        // Draw parameters
        this.minOpacity = _options.minOpacity === undefined ? 1 : _options.minOpacity

        this.createUniforms()
        this.createVertex()
        this.createFragment()
    }

    createVertex()
    {
        super.vertexShader = handdrawnVertexShader
    }

    createFragment()
    {
        super.fragmentShader = handdrawnFragmentShader
    }

    createUniforms()
    {
        this.uniforms = UniformsUtils.merge([
                UniformsLib["lights"],
                {
                    uHatchLight: { value: null },
                    uHatchDark: { value: null },
                    uBaseColor: { value: new Color(this.baseColor) },
                    uColor: { value: null },
                    uColorMapOpacity: { value: this.colorMapOpacity },
                    uColorMapOverlay: { value: new Color(this.colorMapOverlay) },
                    uRoughness: { value: null },
                    uOpacity: { value: null},
                    uMinOpacity: { value: this.minOpacity },
                    uLightPosition: { value: new Vector3() },
                    uViewPosition: { value: new Vector3() },
                }
            ])

        this.uniforms.uHatchDark.value = this.resources.items.hatchdark
        this.uniforms.uHatchLight.value = this.resources.items.hatchlight

        this.uniforms.uColor.value = this.colorMap
        this.uniforms.uRoughness.value = this.roughnessMap
        this.uniforms.uOpacity.value = this.opacityMap
    }
}

HanddrawnMaterial.prototype.isShaderMaterial = true;

export { HanddrawnMaterial }